<section
  class="wilderness-invite"
  [style.--spotlight-x]="spotlightX"
  [style.--spotlight-y]="spotlightY"
  [style.--spotlight-opacity]="spotlightOpacity"
  (pointermove)="updateSpotlight($event)"
  (pointerenter)="activateSpotlight()"
  (pointerleave)="resetSpotlight()"
>
  <div class="wilderness-video-wrap">
    <video class="wilderness-video" autoplay muted loop playsinline>
      <source src="https://karimexclusives.b-cdn.net/acacia/kling_20260410_%E4%BD%9C%E5%93%81_Static_2D__4885_0.webm" type="video/webm" />
      <source src="https://karimexclusives.b-cdn.net/acacia/kling_20260410_%E4%BD%9C%E5%93%81_Static_2D__4885_0.mp4" type="video/mp4" />
    </video>
  </div>
  <div class="wilderness-overlay"></div>
  <div class="wilderness-stage-light"></div>

  <div class="wilderness-content reveal">
    <h2 class="wilderness-title">Enter the Wilderness</h2>
    <p class="wilderness-copy">
      A cinematic pause wrapped in tall grass tones and evening light, carrying the safari spirit deeper
      into the residence experience.
    </p>
    <button class="wilderness-brochure-btn" (click)="openBrochureModal()">Download Brochure</button>
  </div>
</section>
